import SelectFirstAnswerShown from './select_first_answer_shown';

export default class ClearAnswerSearch {
  constructor(context) {
    this.context = context;
  }

  run() {
    let answerPanel = this.context.stores.answerPanel.get();
    answerPanel.clearSearchResult();
    this.context.stores.answerPanel.set(answerPanel);
    this.context.stores.answerPanel.resetPending();
    this.context.executeAction(SelectFirstAnswerShown);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/answers/clear_answer_search.js